import api from '../../utils/api';
import {
  TFilterPreIntake,
  TPreIntake,
  TPreIntakeExportParams
} from '../../types/intake';
import axios from 'axios';
import { cleanParams, serializedObject } from '../../helpers/utils';

const authEndpoint: string = `${process.env.REACT_APP_ENDPOINT}/case/intake/pre-intake`;

const fetchAll = (filters: TFilterPreIntake) => {
  const { province_id, district_id, ...rest } = filters;
  return api.get(
    `${authEndpoint}?${serializedObject(rest)}${
      province_id ? `&province_id=${province_id}` : ''
    }${district_id ? `&district_id=${district_id}` : ''}`
  );
};
const fetchOne = (id: number) => {
  return api.get(`${authEndpoint}/${id}`);
};
const create = (data: TPreIntake) => {
  return axios.post(`${authEndpoint}`, data);
};
const update = (id: number, data: TPreIntake) => {
  return api.put(`${authEndpoint}/${id}`, data);
};
const destroy = (id: number) => {
  return api.delete(`${authEndpoint}/${id}`);
};
const fetchCount = () => {
  return api.get(`${authEndpoint}/getCount`);
};
// Spec #4c §1.2 — pre-case-list export. Same scoping/filters as fetchAll plus a
// required `format`. Returns a file blob; filename comes from the response.
const exportList = (params: TPreIntakeExportParams) => {
  return api.get<Blob>(
    `${authEndpoint}/export?${serializedObject(cleanParams(params))}`,
    {
      responseType: 'blob'
    }
  );
};

export default {
  fetchAll,
  fetchOne,
  create,
  update,
  destroy,
  fetchCount,
  exportList
};
